// @flow
import * as APPDATA from '@/constants/pcConstAppData';

// get profile name from address profile
// ex :
// Address : /api/profiles/9/Profile-0009
// return : Profile 0009
export function GetProfileName(address) {
  return address.slice(address.lastIndexOf('/') + 1).replace(/-/gi, ' ');
}

// check value in in arrayor not
// @param value [string]
// @param array [Array<string>]
// return true or false
export function IsInArray(value, array) {
  return array.indexOf(value) > -1;
}

/**
 * check array is empty or not
 * @param {*} obj
 * @returns {boolean}
 */
export function IsEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// is n Integer?
// @param n [Number]
// return true is int
// retur false is float
export function isInt(n) {
  return n % 1 === 0;
}

// update key JSON to UI Format
// ex :
// JSON --> BufferVolumeToUse : 5
// return bufferVolumeToUse : 5
export function changeFirstKeysToLowerCase(obj) {
  let key;
  let upKey;
  // eslint-disable-next-line no-restricted-syntax
  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      upKey = key.toLowerCase().slice(0, 1) + key.slice(1);
      if (upKey !== key) {
        obj[upKey] = obj[key];
        delete obj[key];
      }
      // recurse
      if (typeof obj[upKey] === 'object') {
        changeFirstKeysToLowerCase(obj[upKey]);
      }
    }
  }
  return obj;
}

export function changeFirstKeysToUpperCase(obj) {
  let key;
  let upKey;
  // eslint-disable-next-line no-restricted-syntax
  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      upKey = key.toUpperCase().slice(0, 1) + key.slice(1);
      if (upKey !== key) {
        obj[upKey] = obj[key];
        delete obj[key];
      }
      // recurse
      if (typeof obj[upKey] === 'object') {
        changeFirstKeysToUpperCase(obj[upKey]);
      }
    }
  }
  return obj;
}

// remove unused properti Json profile
// @param obj [JSONType]
// return obj
export function removeUnusedProfileJson(obj) {
  delete obj.createdAt;
  delete obj.modifiedAt;
  delete obj.pressureTimeLimit;

  return obj;
}

export function removeUnusedAdvSetupJson(obj) {
  delete obj.createdAt;
  delete obj.modifiedAt;

  return obj;
}

export function initialNumberProfileName(str, max) {
  // eslint-disable-next-line no-param-reassign
  str = str.toString();
  return str.length < max ? initialNumberProfileName(`0${str}`, max) : str;
}

/* check is all mandotory profile is filled or not
 * @param profileParam [JSONType]: the number that want to get biggest mod
 * return
 *       true : if all mandatory field is filled
 *       [array of emty field] : if there is mandatory field not filled
 */
export function isAllProfileParamFilled(profileParam) {
  const emptyField = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in profileParam) {
    if (profileParam[prop] === APPDATA.EMPTY_FIELD) {
      // don't care about value of Membrane cut off
      if (prop === APPDATA.KEY.MembraneCutOffSize) continue;
      // don't care about SV2ndTube when more than 50 ml off
      else if (
        prop === APPDATA.KEY.StartingVolumeFor2ndTube &&
        profileParam[APPDATA.KEY.MoreThan50ml] === APPDATA.ENUM.MORE_THAN_50_ML.OFF
      )
        continue;

      // dont care value of volume to start at and buffer volume to use in none diafiltration
      if (profileParam[APPDATA.KEY.DiafiltrationMode] === APPDATA.FIELD_NAME.NONE_DIAFILTRATION) {
        if (
          prop === APPDATA.KEY.VolumeToStartAt ||
          prop === APPDATA.KEY.BufferVolumeToUse ||
          prop === APPDATA.KEY.TotalBufferVolumeToUse
        )
          continue;
        else emptyField.push(prop);
      } else emptyField.push(prop);
    }
  }
  if (emptyField.length === 0) return true;
  return emptyField;
}
export function isAllAutoProfileParamFilled(profileParam) {
  const emptyField = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in profileParam) {
    if (profileParam[prop] === APPDATA.EMPTY_FIELD) {
      if (prop === APPDATA.KEY.MembraneCutOffSize) continue;

      // don't care about SV2ndTube when more than 50 ml off
      if (
        prop === APPDATA.KEY.StartingVolumeFor2ndTube &&
        profileParam[APPDATA.KEY.MoreThan50ml] === APPDATA.ENUM.MORE_THAN_50_ML.OFF
      )
        continue;

      if (profileParam[APPDATA.KEY.MoreThan50ml] === APPDATA.ENUM.MORE_THAN_50_ML.ON) {
        if (prop === APPDATA.KEY.StartingVolumeFor2ndTube) emptyField.push(prop);
        // else {
        //     continue;
        // }
      } else if (profileParam[APPDATA.KEY.DiafiltrationMode] !== APPDATA.FIELD_NAME.NONE_DIAFILTRATION) {
        if (
          prop === APPDATA.KEY.VolumeToStartAt ||
          prop === APPDATA.KEY.BufferVolumeToUse ||
          prop === APPDATA.KEY.TotalBufferVolumeToUse
        ) {
          // check buffer Volume to use Continuous or discreate
          emptyField.push(prop);
        } else if (prop === APPDATA.KEY.ExchangeStepSize) {
          if (profileParam[APPDATA.KEY.DiafiltrationMode] === APPDATA.FIELD_NAME.DISCRETE_DIAFILTRATION) {
            emptyField.push(prop);
          }
        }
        // else {
        //     continue;
        // }
      }

      if (
        prop === APPDATA.KEY.StartingVolume ||
        prop === APPDATA.KEY.StartingConcentration ||
        prop === APPDATA.KEY.EstimatedFinalConcentration ||
        prop === APPDATA.KEY.FinalVolume
      )
        emptyField.push(prop);
      // else {
      //     continue;
      // }
    }
  }
  if (emptyField.length === 0) return true;
  return emptyField;
}

export function isAllAdvSetupParamFilled(advSetupParam) {
  const emptyField = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in advSetupParam) {
    if (advSetupParam[prop] === APPDATA.EMPTY_FIELD) {
      // don't care about value of Membrane cut off
      if (prop === APPDATA.KEY.MembraneCutOffSize) continue;
      // don't care about SV2ndTube when more than 50 ml off
      else if (
        prop === APPDATA.KEY.StartingVolumeFor2ndTube &&
        advSetupParam[APPDATA.KEY.MoreThan50ml] === APPDATA.ENUM.MORE_THAN_50_ML.OFF
      )
        continue;

      // dont care value of volume to start at and buffer volume to use in none diafiltration
      if (advSetupParam[APPDATA.KEY.DiafiltrationMode] === APPDATA.FIELD_NAME.NONE_DIAFILTRATION) {
        if (
          prop === APPDATA.KEY.VolumeToStartAt ||
          prop === APPDATA.KEY.BufferVolumeToUse ||
          prop === APPDATA.KEY.TotalBufferVolumeToUse
        )
          continue;
        else emptyField.push(prop);
      } else emptyField.push(prop);
    }
  }
  if (emptyField.length === 0) return true;
  return emptyField;
}

/**
 * find value in JSON
 * @param json [JSONType]: the number that want to get biggest mod
 * @param value [string]: mod value
 * @returns true when there is a vlaue in JSON else false
 */
export function checkForValue(json, value) {
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in json) {
    if (typeof json[key] === 'object') {
      return checkForValue(json[key], value);
    }
    if (json[key] === value) {
      return true;
    }
  }
  return false;
}

/**
 * create new JSON object
 * @param json [JSONType]
 * @returns new JSON object
 */
export function createNewJsonObject(json) {
  if (json === undefined) return undefined;
  return JSON.parse(JSON.stringify(json));
}

/**
 * get the biggest mod from a number
 * @param number [number]: the number that want to get biggest mod
 * @param mod [number]: mod value
 * @returns the biggest mody
 */
// eslint-disable-next-line consistent-return
export function getTheBiggestMod(number, mod) {
  let loop = true;
  let temp;

  while (loop) {
    temp = number % mod;
    if (temp === 0) {
      loop = false;
      return number;
    }
    // eslint-disable-next-line no-param-reassign
    number -= 1;
  }
}

const comparable = (o) =>
  typeof o !== 'object' || !o
    ? o
    : Object.keys(o)
        .sort()
        // eslint-disable-next-line no-return-assign, no-sequences
        .reduce((c, key) => ((c[key] = comparable(o[key])), c), {});

/**
 * compare JSON is equal or not
 * @param JSON1 [JSONType]: the number that want to get biggest mod
 * @param JSON2 [JSONType]: mod value
 * @returns true : if JSON1 & JSON2 equal
 * @returns false : if JSON1 & JSON2 not equal
 */
export function isEqual(JSON1, JSON2) {
  // ConsoleLog("isEqual", JSON1, JSON2, comparable(JSON1), comparable(JSON2), JSON.stringify(JSON1) === JSON.stringify(JSON2), JSON.stringify(comparable(JSON1)) === JSON.stringify(comparable(JSON2)));
  return JSON.stringify(comparable(JSON1)) === JSON.stringify(comparable(JSON2));
}

export function pad(str, max) {
  // eslint-disable-next-line no-param-reassign
  str = str.toString();
  return str.length < max ? pad(`0${str}`, max) : str;
}

export function spliceString(str, startIndex, endIndex) {
  let sliceString = str;
  sliceString = sliceString.slice(startIndex, endIndex + 1);
  // eslint-disable-next-line no-param-reassign
  str = str.replace(sliceString, '');
  return str;
}

/**
 * Get enum string from enum number
 * Ex :
 * const PAGE = {
 *  PRIME : 2,
 *  RECOVERY : 3,
 *  GENERAL : 1
 * }
 *   getEnumString(1,PAGE)
 *   Will return "GENERAL"
 *
 */
export function getEnumString(enumNumber, enumConstant) {
  if (enumConstant === undefined) return 'UNDEFINED';
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in enumConstant) {
    if (enumConstant[prop] === enumNumber) return prop;
  }
  return 'UNDEFINED';
}

export function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export function setSessionStorage(key, value) {
  sessionStorage.setItem(key, createNewJsonObject(value));
  return {key, value};
}

export function getSessionStorage(key) {
  return sessionStorage.getItem(key);
}

export function removeSessionStorage(key) {
  sessionStorage.removeItem(key);
}

export function ConvertSecondsToHHMMSS(timeInSeconds) {
  const Hours = timeInSeconds / 3600;
  const remainder = timeInSeconds % 3600;
  const Minutes = remainder / 60;
  const Seconds = remainder % 60;
  const timeFormat = `${parseInt(Hours, 10)}:${pad(parseInt(Minutes, 10), 2)}:${pad(parseInt(Seconds, 10), 2)}`;
  return timeFormat;
}

// will return path structure addres from  APPDATA
// wil convert from window.location.href to APPDATA structure
export function GetPathOfPage(address) {
  const startingIndex = address.indexOf('#');
  const path = address.slice(startingIndex, address.length);

  return path;
}

export const isEmptyFieldValue = (value) => value === APPDATA.EMPTY_FIELD; // || (typeof value === 'number' && value === APPDATA.EMPTY_FIELD_NUMERIC);

export const AppHelper = {
  version: 'V2',
  isHardRefresh: false,
  isHandledFallback: false,
  tempTimeZoneState: {
    isAutoSync: true,
    geoArea: '',
    region: '',
    dateTime: new Date(),
  },
};

export function navigateTo(path) {
  window.location.href = path;
}
